module.exports = __webpack_public_path__ + "images/emoji/closed_book.ca3bfc24b3c209911b1a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/closed_book.png
// module id = ieHU
// module chunks = 13